import { PropsWithChildren } from "react";

import { ZodProvider } from "@autoform/zod";
import _ from "lodash";

import { LoadingButton } from "@/components/common/loading-button";
import { AutoForm } from "@/components/ui/autoform";
import { injectCustomAutoFormComponents } from "@/components/ui/autoform/components/custom";
import { ProviderSelectField } from "@/pages/events/components/fields/provider-select-field";
import { TicketingUpdatedAtField } from "@/pages/events/components/fields/ticketing-updated-at-field";
import { useEventCreateForm } from "@/pages/events/create/hooks/use-event-create-form";
import { eventTicketingStepSchema } from "@/pages/events/schemas/event.create.form";

interface EventTicketingInfoStepProps {}

const schemaProvider = new ZodProvider(eventTicketingStepSchema);

export const EventTicketingInfoStep = ({
  children,
}: PropsWithChildren<EventTicketingInfoStepProps>) => {
  const { ticketingStep, loading, onTicketingStepSubmit } =
    useEventCreateForm();

  return (
    <div className="flex flex-col gap-2">
      <AutoForm
        schema={schemaProvider}
        values={ticketingStep}
        onSubmit={onTicketingStepSubmit}
        {...injectCustomAutoFormComponents({
          formComponents: {
            providerSelect: ProviderSelectField,
            ticketingUpdatedAt: TicketingUpdatedAtField,
          },
        })}
      >
        <div className="flex justify-end">
          <LoadingButton isLoading={loading.ticketing === "loading"}>
            Next
          </LoadingButton>
        </div>
      </AutoForm>
    </div>
  );
};
